export enum TeamPlayerRoles {
  CAPTAIN = 'captain',
  DEPUTY = 'deputy_captain',
  DEFAULT = 'default_player'
};

export const ACCOUNTS_TAG = 'Accounts';
export const CURRENT_ACCOUNT_ID = 'Current';
